import styled from '@emotion/styled';

const EditorWrapper = styled('section')({
  marginTop: 6,
  display: 'flex',
  alignItems: 'center',
  ':first-of-type': {
    marginTop: 12,
  },
});

export default EditorWrapper;
